module.exports = __webpack_public_path__ + "img/7-stylists-laserbeamer.png";